module.exports = __webpack_public_path__ + "img/aerialito-white.71d2da99.svg";